import {
  Box,
  Button,
  Flex,
  Heading,
  Image,
  Input,
  InputGroup,
  InputRightElement,
  Text,
} from '@chakra-ui/react';
import { SubMenuNavigation } from 'components/navbar/components';
import { t } from 'i18next';
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { path } from 'utils/const';
import ScanIcon from '../../assets/icon/scan.svg';
import { Search2Icon } from '@chakra-ui/icons';
import TabsPills from 'components/tabs-pills/TabsPills';
import { ProductScanHistoryList } from 'pages/history/product-scans';
import { windowGlobalVar } from 'utils/window-var';

const CheckProduct = () => {
  const history = useHistory();

  const [productUrl, setProductUrl] = useState(null);

  return (
    <Flex
      flexDir="column"
      justifyContent="center"
      alignItems="start"
      w="full"
      pb="50px"
    >
      <Flex
        pt="30px"
        pb="12"
        gap="8"
        flexDir="column"
        justifyContent="center"
        alignItems="center"
        width="full"
        position="relative"
      >
        <SubMenuNavigation
          onClick={() => history.push(path.dashboard)}
          withPattern={true}
        >
          <Text fontSize="20px" color="black" fontWeight="700" gap="8">
            {t('check-a-product.title')}
          </Text>
        </SubMenuNavigation>
      </Flex>

      <Box w="full" px="8">
        <TabsPills
          content={[
            {
              tabTitle: t('check-a-product.scan-product.title'),
              tabBody: t('check-a-product.scan-product.body'),
              tabPanel: (
                <Button
                  minH="56px"
                  fontWeight="400"
                  fontSize="2xl"
                  rounded="full"
                  onClick={() => window[windowGlobalVar.SCAN_REQUEST]('scan')}
                  width="full"
                  iconSpacing="5"
                  py="9"
                  leftIcon={
                    <Image src={ScanIcon} w="full" h="full" objectFit="cover" />
                  }
                >
                  {t('check-a-product.scan-product.tap-start-scan')}
                </Button>
              ),
            },
            {
              tabTitle: t('check-a-product.paste-url.title'),
              tabBody: t('check-a-product.paste-url.body'),
              tabPanel: (
                <InputGroup size="lg">
                  <Input
                    paddingInlineStart="6"
                    fontSize="xl"
                    minH="56px"
                    rounded="full"
                    placeholder={t('check-a-product.paste-url.type-here')}
                    borderColor="#EBEBEB"
                    sx={{
                      '::placeholder': {
                        fontSize: '1.25rem',
                      },
                    }}
                    onKeyUp={(e) =>
                      e.key === 'Enter' &&
                      window[windowGlobalVar.SCAN_REQUEST](
                        'paste-url',
                        productUrl
                      )
                    }
                    onChange={(e) => setProductUrl(e.target.value)}
                  />
                  <InputRightElement
                    fontSize="2xl"
                    top="50%"
                    transform="translateY(-50%)"
                    right="4"
                    color="#1D2433A6"
                    onClick={() =>
                      window[windowGlobalVar.SCAN_REQUEST](
                        'paste-url',
                        productUrl
                      )
                    }
                  >
                    <Search2Icon />
                  </InputRightElement>
                </InputGroup>
              ),
            },
          ]}
        />

        <Heading fontSize="2xl">{t('nav-menu.scan-history')}</Heading>
        <ProductScanHistoryList />
      </Box>
    </Flex>
  );
};

export default CheckProduct;
